import { Link } from 'react-router-dom';

export const PlainTextLink = ({ to, ...props }: { to: string; [key: string]: any }) => {
  return <Link to={to} {...props} style={{ textDecoration: 'none', color: 'inherit' }} />;
};
